import React from 'react';
import { Helmet } from 'react-helmet-async';
import { useTranslation } from 'react-i18next';
import './DeleteAccount.css';

function DeleteAccount() {
  const { t } = useTranslation();
  
  return (
    <>
      <Helmet>
        <title>{t('deleteAccount.seo.title')}</title>
        <meta name="description" content={t('deleteAccount.seo.description')} />
      </Helmet>
      
      <div className="delete-account-page">
        <div className="delete-account-content">
          <div className="delete-account-header">
            <img src="/assets/warning-icon.svg" alt="Warning" className="warning-icon" />
            <h1 className="delete-account-title">{t('deleteAccount.title')}</h1>
          </div>
          
          <p className="delete-account-subtitle">
            {t('deleteAccount.subtitle')}
          </p>
          <div className="local-data-notice">
            <strong>{t('deleteAccount.localDataTitle')}</strong>
            <p>{t('deleteAccount.localDataText')}</p>
          </div>
        </div>
        
        <div className="delete-instructions-box">
          <h2 className="instructions-title">{t('deleteAccount.howToTitle')}</h2>
          <p className="instructions-intro">
            {t('deleteAccount.howToIntro')}
          </p>
          
          <div className="steps-list">
            <div className="step-item">
              <div className="step-number">
                <span>1</span>
              </div>
              <div className="step-content">
                <p className="step-text">
                  {t('deleteAccount.step1')}
                </p>
                <div className="email-format-box">
                  <p className="email-format-label">{t('deleteAccount.emailFormatLabel')}</p>
                  <p className="email-format-text">
                    {t('deleteAccount.emailFormatText')}
                  </p>
                </div>
              </div>
            </div>
            
            <div className="step-item">
              <div className="step-number">
                <span>2</span>
              </div>
              <div className="step-content">
                <p className="step-text">
                  {t('deleteAccount.step2')}
                </p>
              </div>
            </div>
            
            <div className="step-item">
              <div className="step-number">
                <span>3</span>
              </div>
              <div className="step-content">
                <p className="step-text">
                  {t('deleteAccount.step3')}
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
}

export default DeleteAccount;
